import { Connector } from "../../../components/types";

// Icons mapping
export const connectorIcons: Record<string, string> = {
  'Web SDK': '🌐',
  'Mobile SDK': '📱',
  'Postgres': '🐘',
  'MySQL': '🐬',
  'MongoDB': '🍃',
  'BigQuery': '🔍',
  'Snowflake': '❄️',
  'Redshift': '🔴',
  'S3': '📦',
  'Kafka': '⚡',
  'Kinesis': '🌊',
  'GA4': '📊',
  'Branch': '🌿',
  'Webhooks In': '🪝',
  'Elasticsearch': '🔎',
  'Salesforce': '☁️',
  'HubSpot': '🟠',
  'Braze': '🎯',
  'Iterable': '📧',
  'Klaviyo': '📩',
  'SendGrid': '✉️',
  'Shopify': '🛒'
};

export const sourceConnectors: Connector[] = [
  { id: '1', name: 'Web SDK', type: 'Source', status: 'Setup', icon: '🌐' },
  { id: '2', name: 'Mobile SDK', type: 'Source', status: 'Setup', icon: '📱' },
  { id: '3', name: 'Postgres', type: 'Source', status: 'Setup', icon: '🐘' },
  { id: '4', name: 'MySQL', type: 'Source', status: 'Setup', icon: '🐬' },
  { id: '5', name: 'MongoDB', type: 'Source', status: 'Setup', icon: '🍃' },
  { id: '6', name: 'BigQuery', type: 'Source', status: 'Setup', icon: '🔍' },
  { id: '7', name: 'Snowflake', type: 'Source', status: 'Setup', icon: '❄️' },
  { id: '8', name: 'Redshift', type: 'Source', status: 'Setup', icon: '🔴' },
  { id: '9', name: 'S3', type: 'Source', status: 'Setup', icon: '📦' },
  { id: '10', name: 'Kafka', type: 'Source', status: 'Setup', icon: '⚡' },
  { id: '11', name: 'Kinesis', type: 'Source', status: 'Setup', icon: '🌊' },
  { id: '12', name: 'GA4', type: 'Source', status: 'Setup', icon: '📊' },
  { id: '13', name: 'Branch', type: 'Source', status: 'Setup', icon: '🌿' },
  { id: '14', name: 'Webhooks In', type: 'Source', status: 'Setup', icon: '🪝' },
  { id: '28', name: 'Shopify', type: 'Source', status: 'Setup', icon: '🛒' }
];

export const destinationConnectors: Connector[] = [
  { id: '15', name: 'Postgres', type: 'Destination', status: 'Setup', icon: '🐘' },
  { id: '16', name: 'BigQuery', type: 'Destination', status: 'Setup', icon: '🔍' },
  { id: '17', name: 'Snowflake', type: 'Destination', status: 'Setup', icon: '❄️' },
  { id: '18', name: 'Redshift', type: 'Destination', status: 'Setup', icon: '🔴' },
  { id: '19', name: 'S3', type: 'Destination', status: 'Setup', icon: '📦' },
  { id: '20', name: 'Kafka', type: 'Destination', status: 'Setup', icon: '⚡' },
  { id: '21', name: 'Elasticsearch', type: 'Destination', status: 'Setup', icon: '🔎' },
  { id: '22', name: 'Salesforce', type: 'Destination', status: 'Setup', icon: '☁️' },
  { id: '23', name: 'HubSpot', type: 'Destination', status: 'Setup', icon: '🟠' },
  { id: '24', name: 'Braze', type: 'Destination', status: 'Setup', icon: '🎯' },
  { id: '25', name: 'Iterable', type: 'Destination', status: 'Setup', icon: '📧' },
  { id: '26', name: 'Klaviyo', type: 'Destination', status: 'Setup', icon: '📩' },
  { id: '27', name: 'SendGrid', type: 'Destination', status: 'Setup', icon: '✉️' }
];

export const sourceOptions = ['Postgres', 'Shopify', 'MySQL', 'MongoDB', 'Snowflake', 'BigQuery', 'Redshift', 'S3', 'Kafka'];
export const destinationOptions = ['Postgres', 'BigQuery', 'Snowflake', 'Redshift', 'S3', 'Kafka', 'Elasticsearch'];

 export const ServiceIcon: React.FC<{
    src: string;
    alt: string;
    className?: string;
  }> = ({ src, alt, className = "" }) => (
    <div
      className={`w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center shadow-lg border border-gray-700 ${className}`}
    >
      <img src={src} alt={alt} className="w-8 h-8 object-contain" />
    </div>
  );

  const AddIcon: React.FC<{ className?: string }> = ({ className = "" }) => (
    <div
      className={`w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center shadow-lg border border-gray-700 cursor-pointer hover:bg-gray-700 transition-colors ${className}`}
    >
      <svg
        className="w-6 h-6 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        />
      </svg>
    </div>
  );

  export const sourceIcons = [
    {
      id: 1,
      component: (
        <ServiceIcon
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/facebook/facebook-original.svg"
          alt="Facebook"
        />
      ),
      top: "15%",
    },
    {
      id: 2,
      component: (
        <ServiceIcon
          src="https://cdn.worldvectorlogo.com/logos/microsoft-teams-1.svg"
          alt="Microsoft Teams"
        />
      ),
      top: "35%",
    },
    {
      id: 3,
      component: (
        <ServiceIcon
          src="https://cdn.shopify.com/b/shopify-brochure2-assets/d9340911ca8c679b148dd4a205ad2ffa.svg"
          alt="Shopify"
        />
      ),
      top: "55%",
    },
    {
      id: 4,
      component: <AddIcon />,
      top: "75%",
    },
  ];

 export  const destinationIcons = [
    {
      id: 1,
      component: (
        <ServiceIcon
          src="https://companieslogo.com/img/orig/SNOW-35164165.png"
          alt="Snowflake"
        />
      ),
      top: "20%",
    },
    {
      id: 2,
      component: (
        <ServiceIcon
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Amazon-Redshift-Logo.svg/1024px-Amazon-Redshift-Logo.svg.png"
          alt="Amazon Redshift"
        />
      ),
      top: "40%",
    },
    {
      id: 3,
      component: (
        <ServiceIcon
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg"
          alt="SQL Server"
        />
      ),
      top: "60%",
    },
    {
      id: 4,
      component: <AddIcon />,
      top: "80%",
    },
  ];